module.exports = __webpack_public_path__ + "static/media/ishraq_logo.b87b895c.jpg";